<template>
    <div class="popup">
        <div class="popup-content">
            <img src="/img/close-btn.svg" class="close-popup-btn" @click="closePopup" />
            <div class="popup-text">
                <div class="popup-title">
                    <img width="100" height="100" src="/img/complain.svg" />
                </div>
                <div class="popup-description">
                    <i18n-t keypath="dashboard.declineAttentionPopup.description" />
                </div>
            </div>
            <div class="button-container">
                <div>
                    <button class="button-text cancel-button" @click="closePopup">
                        <i18n-t keypath="dashboard.declineAttentionPopup.noButton" />
                    </button>
                </div>
                <div>
                    <button class="button-text decline-button" @click="confirm">
                        <i18n-t keypath="dashboard.declineAttentionPopup.yesButton" />
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>


<style scoped>
.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.popup-content {
    position: relative;
    width: 440px;
    height: 300px;
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 4px;
}

.close-popup-btn {
    width: 24px;
    height: 24px;
    cursor: pointer;
    position: absolute;
    top: 10px;
    right: 10px;
}

.popup-text {
    text-align: center;
}

.popup-title {
    width: 313px;
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    letter-spacing: 0;
    margin-top: 25px;
    margin-left: auto;
    margin-right: auto;
}

.popup-description {
    width: 314px;
    font-size: 18px;
    font-weight: 600;
    line-height: 20px;
    letter-spacing: 0;
    text-align: center;
    background: rgba(40, 55, 71, 1);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    margin-top: 8px;
    margin-left: auto;
    margin-right: auto;
}

.button-container {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    border-top: 1px solid rgba(228, 234, 240, 1);
    padding-top: 21px;
    width: 440px;
    height: 65px;
    margin-left: -20px;
}

.button-container button {
    width: 150px;
    padding: 10px;
}

.button-text {
    font-size: 14px;
    font-weight: 600;
    line-height: 21px;
    letter-spacing: 0;
    text-align: center;
    text-transform: uppercase;
    width: 116px;
    height: 40px;
}

.cancel-button {
    margin-left: 32px;
    color: rgba(26, 160, 225, 1);
    background: white;
    border-radius: 4px;
    border: 1px solid rgba(26, 160, 225, 1);
}

.decline-button {
    margin-right: 32px;
    color: white;
    background: rgba(255, 69, 69, 1);
    border: none;
    border-radius: 4px;
}

.cancel-button:hover,
.decline-button:hover {
    transform: scale(1.05);
}
</style>
<script lang="ts">
import { DeclineAttentionPopup } from "@/dashboard/my-orders/new-popup/decline-attention-popup/decline-attention-popup";

export default DeclineAttentionPopup;
</script>
